export default "__VITE_ASSET__6b5e7a19__"